import { render, staticRenderFns } from "./ActionBtn.vue?vue&type=template&id=a84ee1e4&scoped=true"
import script from "./ActionBtn.vue?vue&type=script&lang=js"
export * from "./ActionBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84ee1e4",
  null
  
)

export default component.exports